import { createContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { auth } from '../utils/auth';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const initializeAuth = async () => {
      try {
        const storedUser = localStorage.getItem('user');
        if (auth.isAuthenticated() && storedUser) {
          let parsedUser;
          try {
            parsedUser = JSON.parse(storedUser);
            setUser(parsedUser);
          } catch (e) {
            console.error('Invalid user data in localStorage:', e);
            localStorage.removeItem('user');
            localStorage.removeItem('token');
            if (!window.location.pathname.includes('/login')) {
              toast.error('Session invalid. Please log in again.', { toastId: 'session-invalid' });
            }
          }
        }
      } catch (error) {
        console.error('Auth initialization error:', error);
        if (!window.location.pathname.includes('/login')) {
          toast.error('Failed to initialize session.', { toastId: 'auth-init-error' });
        }
      } finally {
        setIsLoading(false);
      }
    };

    initializeAuth();
  }, []);

  const login = async (email, password, navigate) => {
    console.log('AuthProvider login called with email:', email); // Debug log
    try {
      const userData = await auth.login(email, password);
      console.log('auth.login successful, userData:', userData); // Debug log
      setUser(userData);
      if (userData.role === 'admin') {
        navigate('/admin');
      } else if (userData.role === 'user') {
        navigate('/user');
      } else if (userData.role === 'farmer') {
        navigate('/farmer');
      } else if (userData.role === 'specialist') {
        navigate('/user');
      } else if (userData.role === 'waste_collector') {
        navigate('/waste-collector');
      } else {
        toast.error('Unknown role. Redirecting to home.', { toastId: 'unknown-role' });
        navigate('/');
      }
      return userData;
    } catch (error) {
      console.error('Login error in AuthProvider:', error.message, error.stack); // Debug log
      // Use the raw API error message
      const errorMessage = error.message || 'Failed to log in';
      toast.error(errorMessage, { toastId: 'login-error' });
      throw new Error(errorMessage);
    }
  };

  const logout = async () => {
    try {
      await auth.logout();
      setUser(null);
      toast.success('Logged out successfully', { toastId: 'logout-success' });
    } catch (error) {
      console.error('Logout error:', error);
      toast.error('Failed to log out', { toastId: 'logout-error' });
    }
  };

  const value = {
    user,
    isLoading,
    login,
    logout,
    isAuthenticated: auth.isAuthenticated,
    isAdmin: auth.isAdmin,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};